export function getNavbarHeight(fallbackNavHeight = 72) {
  if (typeof window === "undefined") return fallbackNavHeight;

  const fixedNavbar =
    document.getElementById("site-navbar") ||
    document.querySelector("header[id='site-navbar']") ||
    document.querySelector("header");

  return fixedNavbar?.getBoundingClientRect().height ?? fallbackNavHeight;
}

function getTabsOverlayHeight(tabsRef) {
  if (!tabsRef?.current || typeof window === "undefined") return 0;

  const position = window.getComputedStyle(tabsRef.current).position;
  if (position !== "fixed" && position !== "sticky") return 0;

  return tabsRef.current.getBoundingClientRect().height;
}

export function getFixedHeaderOffset(tabsRef, fallbackNavHeight = 72) {
  const navbarHeight = getNavbarHeight(fallbackNavHeight);
  const tabsBarHeight = getTabsOverlayHeight(tabsRef);

  return navbarHeight + tabsBarHeight;
}

export function scrollToSectionElement(
  element,
  { tabsRef, extraGap, fallbackNavHeight = 72 } = {}
) {
  if (!element || typeof window === "undefined") return;

  const isMobile = window.innerWidth < 900;
  const gap = extraGap ?? (isMobile ? 0 : 8);
  const offset = getFixedHeaderOffset(tabsRef, fallbackNavHeight) + gap;
  const top = element.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
}

export function scrollToSectionById(
  sectionId,
  options = {}
) {
  if (!sectionId || typeof window === "undefined") return false;

  const element = document.getElementById(sectionId);
  scrollToSectionElement(element, options);
  return Boolean(element);
}
